export default __webpack_public_path__ + "static/media/doc.9bd123b3.jpeg";